import {
  ADD_NEW_PROFILE,
  ADD_PROFILE_ERROR,
  ADD_PROFILE_SUCCESS,
  DELETE_PROFILE,
  DELETE_PROFILE_ERROR,
  DELETE_PROFILE_SUCCESS,
  PROFILE_DATA,
  PROFILE_DATA_ERROR,
  PROFILE_DATA_SUCCESS,
  TRACK_CATEGORY_VALUE,
  TRACK_CATEGORY_VALUE_ERROR,
  TRACK_CATEGORY_VALUE_SUCCESS,
  UPDATE_PROFILE,
  UPDATE_PROFILE_ERROR,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_WORK_REPORT,
  UPDATE_WORK_REPORT_ERROR,
  UPDATE_WORK_REPORT_SUCCESS,
} from "./actiontype"

export const getAllCategory = () => {
  return {
    type: TRACK_CATEGORY_VALUE,
  }
}
export const getAllCategorySuccess = category => {
  return {
    type: TRACK_CATEGORY_VALUE_SUCCESS,
    payload: category,
  }
}

export const getAllCategoryError = screens => {
  return {
    type: TRACK_CATEGORY_VALUE_ERROR,
    payload: screens,
  }
}

//track grid Datas
export const getprofiledata = params => {
  return {
    type: PROFILE_DATA,
    payload: params,
  }
}
export const profileDataSuccess = data => {
  return {
    type: PROFILE_DATA_SUCCESS,
    payload: data,
  }
}

export const profileDataError = erordata => {
  return {
    type: PROFILE_DATA_ERROR,
    payload: erordata,
  }
}

// add new Profile
export const onAddNewProfile = (profile, callback) => ({
  type: ADD_NEW_PROFILE,
  payload: profile,
  callback,
})

export const addprofileSuccess = profile => ({
  type: ADD_PROFILE_SUCCESS,
  payload: profile,
})

export const addprofileFail = error => ({
  type: ADD_PROFILE_ERROR,
  payload: error,
})
// profile update
export const onUpdateProfile = (profile, callback) => ({
  type: UPDATE_PROFILE,
  payload: profile,
  callback,
})

export const updateprofileSuccess = profile => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: profile,
})

export const updateprofileFail = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
})
export const workReport = (params, callback) => {
  return {
    type: UPDATE_WORK_REPORT,
    payload: params,
    callback,
  }
}
export const workReportSuccess = profile => ({
  type: UPDATE_WORK_REPORT_SUCCESS,
  payload: profile,
})
export const workReportFail = error => ({
  type: UPDATE_WORK_REPORT_ERROR,
  payload: error,
})
export const onDeleteProfile = id => ({
  type: DELETE_PROFILE,
  payload: id,
})

export const deleteprofileSuccess = id => ({
  type: DELETE_PROFILE_SUCCESS,
  payload: id,
})

export const deleteprofileFail = error => ({
  type: DELETE_PROFILE_ERROR,
  payload: error,
})
